import { useQuery } from '@apollo/client'
import { isScreenerDisplayLogicEnabled } from '../../constants/featureFlags'
import {
  AudienceQuestionLogicData,
  GET_AUDIENCE_QUESTION_LOGIC
} from '../../data/gql/questionnaire/queries/audienceQuestionLogic'
import { LoggerErrorType } from '../../data/logger'
import { AudienceQuestionLogic } from '../../data/model/audienceQuestionLogic'
import { captureApolloError } from '../../utils/HelperFunctions'
import { useOptionalWaveId } from '../useOptionalWaveId'
import { useProjectId } from '../useProjectId'
import { useSurveyId } from '../useSurveyId'

// Keyed as the rest of the module keys members: criterion question id for standard, questionLk for custom.
export const useGetAudienceQuestionLogic = (): Map<
  string,
  AudienceQuestionLogic
> => {
  const projectId = useProjectId()
  const surveyId = useSurveyId()
  const waveId = useOptionalWaveId()

  const { data } = useQuery<AudienceQuestionLogicData>(
    GET_AUDIENCE_QUESTION_LOGIC,
    {
      context: { clientName: 'questionnaire' },
      variables: { projectId, surveyId, waveId },
      skip: !isScreenerDisplayLogicEnabled(),
      onError: (error) => {
        captureApolloError(
          LoggerErrorType.ApolloQuery,
          'audienceQuestionLogic',
          error
        )
      }
    }
  )

  return new Map(
    (data?.draftAudience?.members ?? []).flatMap((member) => {
      const questionId =
        member.memberItem.criterion?.question.questionId ??
        member.memberItem.questionLk

      return questionId ? [[questionId, member.memberItem.questionLogic]] : []
    })
  )
}
